import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import render from '@tk/utilities/tk.render';

export default class TEMainnav extends TKCustomElementFactory {
    triggerList: NodeListOf<HTMLButtonElement>;
    container?: HTMLElement;
    contentUrl?: string;
    navOpen: boolean = false;
    navOpenClass: string;
    closeBtns: HTMLButtonElement[];
    currentNav?: string;

    constructor() {
        super();
        this.triggerList = this.querySelectorAll('[data-tk-trigger]');
        this.container = this.querySelector('[data-tk-container]') || undefined;
        this.contentUrl = this.getAttribute('data-tk-content-url') || undefined;
        this.navOpenClass = this.getAttribute('data-tk-open-class') || 'mainnav--open';

        const closeButtonsList = Array.from(this.querySelectorAll<HTMLButtonElement>('[data-tk-close-btn]'));
        const burgerBtn = document.querySelector<HTMLButtonElement>('[data-tk-burger]');
        if (burgerBtn) {
            closeButtonsList.push(burgerBtn);
        }

        this.closeBtns = closeButtonsList as HTMLButtonElement[];
    }

    connectedCallback(): void {
        if (!this.container || !this.contentUrl) throw new Error('TEMainnav: missing element');

        this.registerListener(this.triggerList, this.closeBtns);
    }

    registerListener(links: NodeListOf<HTMLButtonElement>, closeBtn: HTMLButtonElement[]) {
        const action = this.toggleNav.bind(this);

        links.forEach((btn) => {
            this.pushListener({ event: 'click', element: btn, action });
        });

        const closeAction = this.closeNav.bind(this);
        closeBtn.forEach((btn) => {
            this.pushListener({ event: 'click', element: btn, action: closeAction });
        });
    }

    toggleNav(e: Event) {
        const target = e.target as HTMLElement;
        const trigger = target.closest('[data-tk-trigger]');
        const catStruct = trigger!.getAttribute('data-tk-trigger');

        if (this.currentNav === catStruct) {
            this.closeNav();
            return;
        }

        this.currentNav = catStruct!;

        const data = {
            parentElement: catStruct,
        };

        fetchRequest({
            requestURL: this.contentUrl!,
            resolveHandler: this.replaceNavContent.bind(this),
            payload: data,
        });
    }

    replaceNavContent(response: TKResponse) {
        if (!response.success) return;

        const body = render(response.dataAsHtml);

        this.container!.replaceChildren(body);

        const additionalTrigger: NodeListOf<HTMLButtonElement> = body.querySelectorAll('[data-tk-trigger]');
        const additionalCloseBtn: HTMLButtonElement[] = Array.from(body.querySelectorAll('[data-tk-close-btn]'));

        this.registerListener(additionalTrigger, additionalCloseBtn);

        this.classList.add(this.navOpenClass);
    }

    closeNav() {
        this.classList.remove(this.navOpenClass);
        this.currentNav = undefined;
    }
}
